//@flow
import React from 'react';
import {TableCell, TableHead, TableRow, makeStyles} from '@material-ui/core';

import type {Theme} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles((theme: Theme) => ({
  tableHead: {
    background: colors.grey200,
  },
  tableRowHead: {
    fontWeight: 600,
    fontSize: '.875rem',
    whiteSpace: 'nowrap',
  },
}));

const TABLE_CELLS = [
  {
    label: 'Nº de orden',
    id: 'orderId',
  },
  {
    label: 'Nº de documento',
    id: 'documentId',
  },
  {
    label: 'Fecha',
    id: 'date',
  },
  {
    label: 'Cliente',
    id: 'customer',
  },
  {
    label: 'Recibo Emitido',
    id: 'document',
  },
  {
    label: 'Estado',
    id: 'state',
  },
  {
    label: 'Monto',
    id: 'amount',
  },
  {
    label: 'Acción',
    id: 'action',
  },
];

export default function TaxInvoiceTableHeader() {
  const classes = useStyles();
  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        {TABLE_CELLS.map(cell => (
          <TableCell
            key={cell.id}
            align="center"
            className={classes.tableRowHead}
          >
            {cell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
